





























































































import { Component, Vue } from 'vue-property-decorator';
import { ApiClient, apiClient } from '@/api/ApiClient';
import moment from 'moment';
import OptionalValue from '@/components/OptionalValue.vue';
import TickCross from '@/components/TickCross.vue';
import { download } from '@/utils/file';
import {
  successNotify,
} from "@/utils/formHelper";

@Component({
  components: {
    OptionalValue,
    TickCross,
  },
})
export default class extends Vue {

  public get moment() {
    return moment;
  }

  // mail report
  public showMailReportDialog = false;

  // table filter
  public serviceTypeSms: number = null;

  public range: Date[] = [moment.utc().local().startOf('month').toDate(), new Date()];
  public customerId: number = null;
  public get customer() {
    if(!this.customerId) {
      return {};
    }

    return this.customers.find(p => p.id === this.customerId) || {};
  }

  public get hasMail() {
    return this.customer ?
      this.customer.customerNotificationAlerts.some(p => p.walletReportUsage || p.walletReportTopUp):
      false;
  }

  // table
  public isTopUpTableLoading = false;
  public topUpPageSize = 100;
  public topUpTotal = 0;
  public topUpCurrentPage = 1;
  public topUps: any[] = [];

  // smss
  public isSmsTableLoading = false;
  public smsPageSize = 100;
  public smsTotal = 0;
  public smsCurrentPage = 1;
  public smss: any[] = [];

  // whatsApps
  public isWhatsAppTableLoading = false;
  public whatsAppPageSize = 100;
  public whatsAppTotal = 0;
  public whatsAppCurrentPage = 1;
  public whatsApps: any[] = [];

  // filter data
  public customers: any[] = [];
  public services: any[] = [];
  public get serviceTypeSmss() {
    const service = this.services.filter(p => p.serviceTypeSmss)[0];
    if (service) {
      return service.serviceTypeSmss;
    }

    return [];
  }

  public mounted() {
    this.loadData();
  }

  // form event
  public async onSendMailReport() {
    const loading = this.$loading({});
    try {
      const [from, to] = this.range || [] as Date[];
      const response = await apiClient.customersReportEmail(this.customerId, {
        from,
        to,
      });
      this.showMailReportDialog = false;
      successNotify.bind(this)();
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.close();
    }
  }

  // filter event
  public async onClickLastMonth() {
    const time = moment().local().add(-1, "M");
    this.range = [
      time.startOf('month').toDate(),
      time.endOf('month').toDate(),
    ];

    await this.loadTable();
  }

  public async onClickThisMonth() {
    this.range = [moment().local().startOf('month').toDate(), new Date()];
    await this.loadTable();
  }

  // filter button
  public async onExportReportWorkbook() {
    const loading = this.$loading({});
    try {
      const [from, to] = this.range || [] as Date[];
      const response = await apiClient.customersReportExportSpreadsheet(this.customerId, {
        from,
        to,
        serviceTypeSmsId: this.serviceTypeSms || undefined,
      });
      download(response);
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.close();
    }
  }

  public async onExportReportPdf() {
    const loading = this.$loading({});
    try {
      const [from, to] = this.range || [] as Date[];
      const response = await apiClient.customersReportExportPdf(this.customerId, {
        from,
        to,
        serviceTypeSmsId: this.serviceTypeSms || undefined,
      });
      download(response);
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.close();
    }
  }

  public onMailReport() {
    this.showMailReportDialog = true;
  }

  // table events
  public async onChangeTopUpPagination() {
    await this.loadTopUps();
    this.$scrollTo("#data-table");
  }

  public async onChangeSmsPagination() {
    await this.loadSmss();
    this.$scrollTo("#data-table");
  }

  public async onChangeWhatsAppPagination() {
    await this.loadWhatsApps();
    this.$scrollTo("#data-table");
  }


  // loads
  private async loadData() {
    await Promise.all([
      this.loadServices(),
      this.loadTable(),
      this.loadCustomers(),
    ]);
  }

  private async loadTable() {
    await Promise.all([
      this.loadTopUps(),
      this.loadSmss(),
      this.loadWhatsApps(),
    ]);
  }

  private async loadServices() {
    const { data } = await apiClient.services();
    this.services = data;
  }

  private async loadTopUps() {
    if (!this.customerId) {
      return;
    }

    this.isTopUpTableLoading = true;
    const range = this.range || [];

    const { data } = await apiClient.customersReportTopUp(this.customerId, {
      take: this.topUpPageSize,
      page: this.topUpCurrentPage,

      from: range[0],
      to: range[1],
    });

    this.topUpTotal = data.count;
    this.topUps = data.data;
    this.isTopUpTableLoading = false;
  }

  private async loadSmss() {
    if (!this.customerId) {
      return;
    }

    this.isSmsTableLoading = true;
    const range = this.range || [];

    const { data } = await apiClient.customersReportSms(this.customerId, {
      take: this.smsPageSize,
      page: this.smsCurrentPage,
      serviceTypeSmsId: this.serviceTypeSms || undefined,

      from: range[0],
      to: range[1],
    });

    this.smsTotal = data.count;
    this.smss = data.data;
    this.isSmsTableLoading = false;
  }

  private async loadWhatsApps() {
    if (!this.customerId) {
      return;
    }

    this.isWhatsAppTableLoading = true;
    const range = this.range || [];

    const { data } = await apiClient.customersReportWhatsApp(this.customerId, {
      take: this.whatsAppPageSize,
      page: this.whatsAppCurrentPage,

      from: range[0],
      to: range[1],
    });

    this.whatsAppTotal = data.count;
    this.whatsApps = data.data;
    this.isWhatsAppTableLoading = false;
  }

  private async loadCustomers() {
    const { data } = await apiClient.customers({
      take: Number.MAX_SAFE_INTEGER,
    });
    this.customers = data.data;
  }
}
